import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { List, Container } from '../base';

const Nav = props => {
  const navClassName = classNames({
    'navbar-collapse': true,
    collapse: !props.expanded,
    [props.className]: props.className,
  });

  return (
    <div className={navClassName} style={{ top: props.topPosition }}>
      {props.children}
    </div>
  );
};

Nav.propTypes = {
  topPosition: PropTypes.number,
  expanded: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

const NavItem = props => {
  const [alreadyHovered, setAlreadyHovered] = useState(false);

  const handleOnItemHover = () => {
    if (!alreadyHovered) {
      setAlreadyHovered(true);
    }
  };

  return (
    <List.Item className="nav-item" onHover={handleOnItemHover}>
      {props.link}
      {alreadyHovered && props.hasChild && (
        <div className="nav-canvas">
          <Container>{props.children}</Container>
        </div>
      )}
    </List.Item>
  );
};

NavItem.propTypes = {
  hasChild: PropTypes.bool,
  link: PropTypes.node,
  children: PropTypes.node,
};

Nav.Item = NavItem;

export default Nav;
